<template lang="pug">
    m-form(class="py-0 m-form-risk-assessment-notice" ref="form" :disableDivider="true")
        template(#content-template="")
            m-block-form-fields(child)
                template(#title="") {{$t(`modules.forms.${name}.sections.text.title`)}}

                e-input-risk-assessment-notice-text(v-model="form.text")

            e-input-image(ref="inputFile" v-model="form.images" @removeFiles="removeFiles" @uploadFailed="uploadFailed"  :raId="raId" :key="key")

        template(#buttons="")
            m-block-form-buttons(:is-loading="$wait.waiting(keys.riskAssessments.update) || filesLoading"
                                 :show-cancel-button="false"
                                 :text="{submit: $t(`modules.forms.${name}.buttons.submit`)}"
                                 @submit="submit")
</template>
<script>
    import notifications from "@mixins/includes/_notifications";
    import baseForm from '@mixins/components/modules/forms/base'

    let name = 'm-form-risk-assessment-notice';
    export default {
        name: name,
        mixins: [baseForm, notifications],
        props: {
            name: {
                type: String,
                default: name
            },
            answer:{
                type: Object
            },
            raId: {
                type: String,
                required: false
            }
        },
        data: () => ({
            form: {
                text: '',
                images: []
            },
            filesLoading:false,
            key: 1
        }),
        created(){
            if(this.answer && this.answer.answer){
                this.form.text = this.answer.answer.text;
                this.form.images = this.answer.answer.images;
            }
        },
        methods: {
            removeFiles(toRemove){
                let remainingImages = this.form.images.filter( function( el ) {
                    return toRemove.indexOf( el ) < 0;
                });
                this.form.images = remainingImages
            },
            async submit() {
                const valid = await this.$validator.validateAll();
                if (valid) {
                    try {
                        // We need filesLoading flag because files uploading not handled by jsonapi-vuex
                        this.filesLoading = true;
                        await this.$refs.inputFile.uploadFiles();
                        this.filesLoading = false;
                        this.$emit('submit:notice', this.form)
                    } catch (e) {
                        this.filesLoading = false;
                        this.error.handle(e);
                    }
                } else {
                    this.filesLoading = false;
                    const el = document.querySelector(".v-messages__message");
                    el.scrollIntoView({behavior: "smooth" ,block: "center"});
                    this.notify.error(this.$t('notifications.errors.formErrors.invalid'))
                }
            },
            uploadFailed(){
                this.filesLoading = false;
                this.notify.error(this.$t('notifications.errors.media.uploadFailed'))
                this.key++;
            }
        }
    }
</script>

<style lang="scss">
   .m-form-risk-assessment-notice {
       .e-typography-heading-3 {
           margin-left: 0 !important;
       }

       /deep/ .m-form-content-template {
           margin-top: 0px !important;
           .flex {
              max-width: 100% !important;
               width: 100% !important;
           }
           .offset-sm {
               margin-left: 0px !important;
           }
           .offset-md1 {
               margin-left: 0px !important;
           }
       }
   }
</style>
